export default "__VITE_ASSET__D2DxgSj2__"